import { useContext} from 'react';
import ReferenceContext from '../context/ReferenceProvider';

const useReference = () => {    
    return useContext(ReferenceContext);
}

export default useReference;